module.exports = __webpack_public_path__ + "static/img/mapa_eng.4b7dbdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/mapa_eng.png
// module id = pr4D
// module chunks = 0